<app-nav></app-nav>
<div class="container px-2">
    <h6 class="policy-heading pt-3">Your Policies</h6>
    <div class="policy-content border rounded px-3 py-2 mb-2">
        <div class="d-flex justify-content-between">
            <span class="policy-name">Family Health Insurance-116WQS</span>
            <span class="fa fa-edit"></span>
        </div>
        <div class="row m-0">
            <div class="col-6 p-0">
                <span class="insurer-detail py-2">Insurer : Royal Sunderum</span>
                <span class="insurer-description pb-2">Sum Insured</span>
                <span class="insured-amounts pb-2">Rs. 10,00,00</span>
            </div>
            <div class="col-6 p-0">
                <span class="insurer-detail py-2">Expiry Date : 10/09/2019</span>
                <span class="insurer-description pb-2">Premium Paid</span>
                <span class="insured-amount pb-2">Rs. 200,00,00</span>
            </div>
        </div>
    </div>
    <div class="policy-content border rounded px-3 py-2 mb-2">
        <div class="d-flex justify-content-between">
            <span class="policy-name">Family Health Insurance-116WQS</span>
            <span class="fa fa-edit"></span>
        </div>
        <div class="row m-0">
            <div class="col-6 p-0">
                <span class="insurer-detail py-2">Insurer : Royal Sunderum</span>
                <span class="insurer-description pb-2">Sum Insured</span>
                <span class="insured-amounts pb-2">Rs. 10,00,00</span>
            </div>
            <div class="col-6 p-0">
                <span class="insurer-detail py-2">Expiry Date : 10/09/2019</span>
                <span class="insurer-description pb-2">Premium Paid</span>
                <span class="insured-amount pb-2">Rs. 200,00,00</span>
            </div>
        </div>
    </div>
    <div class="text-center my-3">
        <button class="btn see-all-btn">See All</button>
    </div>
    <div class="p-3 border rounded mb-2 tab-btn">
        <span><i class="fa fa-trash"></i>&nbsp;&nbsp;&nbsp;&nbsp; E-Cards</span>
    </div>
    <div class="p-3 border rounded mb-2 tab-btn">
        <span><i class="fa fa-trash"></i>&nbsp;&nbsp;&nbsp;&nbsp; Hospital Locator</span>
    </div>
    <div class="p-3 border rounded mb-2 tab-btn">
        <span><i class="fa fa-trash"></i>&nbsp;&nbsp;&nbsp;&nbsp; Add Policy</span>
    </div>
</div>

<!-- <div class="policy-content border rounded">
    <div class="d-flex justify-content-between">
        <span class="policy-name">Family Health Insurance-116WQS</span>
        <span class="fa fa-edit"></span>
    </div>
    <div class="d-flex justify-content-between insurer-detail py-2">
        <span>Insurer : Royal Sunderum</span>
        <span>Expiry Date : 10/09/2019</span>
    </div>
    <div class="d-flex justify-content-between insurer-description pb-2">
        <span>Sum Insured</span>
        <span>Premium Paid</span>
    </div>
    <div class="d-flex justify-content-between insured-amount pb-2">
        <span>Rs. 10,00,00</span>
        <span>Rs. 200,00,00</span>
    </div>
</div> -->